import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'
import XMLClass from '../../classes/xml'
const xml = new XMLClass()
const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const paiesComptasSlice = createSlice({
    name: 'paiesComptas',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDetailsPaiesComptas.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsPaiesComptas.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchDetailsPaiesComptas.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(fetchPaiesComptas.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchPaiesComptas.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchPaiesComptas.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(payComptaPaiesCompta.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(payComptaPaiesCompta.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(payComptaPaiesCompta.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deletePaiesCompta.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deletePaiesCompta.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deletePaiesCompta.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchPaiesComptas = createAsyncThunk(
    'paiesComptas/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/rh.paie.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch paiesComptas')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsPaiesComptas = createAsyncThunk(
    'PaiesComptas/fetchDetails',
    async (id) => {
        try {
            const journal = await BaseService.post(
                `/XML/compta.jr.load/get_journal_by_lbl`, { 'lbl': 'PAIE__' + id.id }
            )
            const fiche = await BaseService.post(
                `/XML/rh.paie.load/get_fiche_de_paie_one_paie`, { 'id': id.id }
            )
            const paie = await BaseService.post(
                `/XML/rh.paie.load/get_one_paie`, { 'id': id.id }
            )

            return { 'journal': journal.data, 'fiche': fiche.data, 'paie': paie.data }
        } catch (error) {
            throw new Error('Failed to fetch PaiesComptas')
        }
    }
)




export const uploadPaiesCompta = createAsyncThunk(
    'paiesComptas/upload',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {

            const response = await BaseService.post('/XML/compta.paie.send/BDS', data)

            if (response.status === 200) {
                xml.damancom(response.data.name, response.data.txt)
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    })



export const comptaPaiesCompta = createAsyncThunk(
    'paiesComptas/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/compta.jr.send/compta_paie', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/comptabilite/Paie')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)



export const payComptaPaiesCompta = createAsyncThunk(
    'paiesComptas/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            for (let i = 0; i < data?.comptes?.length; i++) {
                const element = data?.comptes[i];
                element.id_paie = data?.id_paie
                element.apayer = element.a_payer
                element.compte = element.compte.split('_')[1]
                await BaseService.post('/XML/tr.ba.send/pay_paie_compta', element)

            }


            resetForm()
            setSubmitting(false)
            popNotification(creation?.success)
            navigate('/comptabilite/Paie')

        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)


export const editPaiesCompta = createAsyncThunk('paiesComptas/edit', async (payload) => {
    const { data, formik, navigate } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.put(`/paiesComptas/${data?.id}`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/paiesComptas')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})

export const deletePaiesCompta = createAsyncThunk(
    'paiesCompta/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/paiesComptas/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.paiesComptas.data
export const selectIsLoading = (state) => state.paiesComptas.isLoading
export const selectError = (state) => state.paiesComptas.error
export const selectIsDeleted = (state) => state.paiesComptas.isDeleted
export const selectCurrentPage = (state) => state.paiesComptas.currentPage

export default paiesComptasSlice.reducer
